import { useContext } from "react";
import DashboardContext from "../components/providers/DashboardDetailsProvider";

export function useDashboardDetails() {
  return useContext(DashboardContext)
}
